var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React from 'react';
import { Field, formValues } from 'redux-form';
import { objMap, camelToTitleCase } from './utils';
import resolveValidate from './resolve-validate';
import { visibleIf, validateIf } from './conditional-rendering';
/**
 * Generate fields for a `redux-form` from a schema.
 * @param {object} UIKit - A map of field types to react components.
 * @param {string} formName - The name of the form.
 * @param {object} schema  - The schema to use.
 * @returns {object[]} - An array of field react elements.
 */

export default function createFields(UIKit, formName, schema) {
  return objMap(schema, function (rawField, fieldKey) {
    var placeholder = rawField.props && rawField.props.placeholder ? rawField.props.placeholder : camelToTitleCase(fieldKey);

    var field = _extends({}, rawField, {
      validate: rawField.validate ? resolveValidate(placeholder, rawField.validate) : null,
      props: _extends({}, rawField.props, {
        placeholder: placeholder
      })
    });

    var Component = UIKit[field.type]; // Conditional rendering

    if (field.visibleIf) {
      Component = visibleIf(Component, field.visibleIf);
      field.validate = field.validate && validateIf(field.validate, field.visibleIf);
    } // Access form values


    if (field.formValues) Component = formValues(field.formValues)(Component);
    return React.createElement(Field, _extends({
      key: formName + '-' + fieldKey,
      name: fieldKey,
      component: Component,
      validate: field.validate,
      props: _extends({
        style: {
          flex: 1
        }
      }, field.props)
    }, field.reduxFormFieldProps));
  });
}